import React from 'react';
import useLocationSearchParams from '@medflex/hooks/useLocationSearchParams';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import Modal from '@medflex/components/stories/Modal';
import { useHistory } from 'react-router';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import Logger from '@medflex/utils/Logger';
import { trackEvent } from '@medflex/utils/Tracking';
import useSessionChat from '../../hooks/useSessionChat';
import useModal from '../../hooks/useModal';

const SessionChatDeleteMessagesModal = () => {
  const history = useHistory();
  const { close } = useModal();
  const { id } = useLocationSearchParams();
  const { deleteMessages } = useSessionChat({ id });
  const { t } = useTranslation('messenger');

  const handleClose = () => {
    history.goBack();
  };

  const handleOnClick = async event => {
    event.preventDefault();
    try {
      await deleteMessages();
      trackEvent(event, {
        actionText: 'messages deleted',
      });
      showSuccessToast(t('SessionChatDeleteMessages.successMessage'), null, {
        toastId: 'sessionChatDeleteSuccess',
      });
      close({ modal: 'sessionChatDeleteMessages', id });
    } catch (e) {
      Logger.error(e);
      showAlertToast(t('SessionChatDeleteMessages.unexpectedError'), null, {
        toastId: 'sessionChatDeleteFailed',
      });
    }
  };

  return (
    <Modal
      title={t('SessionChatDeleteMessages.title')}
      onClickCloseButton={handleClose}
      showCloseButton
    >
      <div data-component="SessionChatDeleteMessagesModal">
        <div className="mb-6">{t('SessionChatDeleteMessages.description')}</div>
        <footer className="flex justify-center">
          <Button onClick={handleOnClick}>{t('SessionChatDeleteMessages.submit')}</Button>
        </footer>
      </div>
    </Modal>
  );
};

export default SessionChatDeleteMessagesModal;
